export function isValidCNPJ(cnpj) {
  if (!cnpj) return false;

  const sanitized = String(cnpj).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (sanitized.length !== 14) return false;
  if (/^([A-Z0-9])\1+$/.test(sanitized)) return false;
  if (!/^\d{2}$/.test(sanitized.substring(12))) return false;

  const valorChar = ch => ch.charCodeAt(0) - 48;
  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  let soma1 = 0;
  for (let i = 0; i < 12; i++) {
    soma1 += valorChar(sanitized.charAt(i)) * pesos1[i];
  }
  const dv1 = soma1 % 11 < 2 ? 0 : 11 - (soma1 % 11);
  if (dv1 !== parseInt(sanitized.charAt(12), 10)) return false;

  let soma2 = 0;
  for (let j = 0; j < 13; j++) {
    soma2 += valorChar(sanitized.charAt(j)) * pesos2[j];
  }
  const dv2 = soma2 % 11 < 2 ? 0 : 11 - (soma2 % 11);
  return dv2 === parseInt(sanitized.charAt(13), 10);
}

function validateCnpj(value) {
  if (!value) return true;
  return isValidCNPJ(value);
}

export default Object.assign(validateCnpj, {
  methods: {
    isValidCNPJ,
  },
});
